import type { SandboxControl } from '../../../lib/api/operatorConsole';
import { Button } from '../../../components/ui/Button';

interface Props {
  label: string;
  runningLabel: string;
  hint: string;
  control: SandboxControl;
  running: boolean;
  busy: boolean;
  onClick: () => void;
}

// The backend decides availability; an unavailable action shows its reason in
// place of the hint, so the partner sees why without hovering.
export function SandboxActionRow({
  label,
  runningLabel,
  hint,
  control,
  running,
  busy,
  onClick,
}: Props) {
  return (
    <li className="flex flex-wrap items-center gap-3 py-2">
      <Button
        type="button"
        variant="ghost"
        className="min-w-36 px-3 py-1"
        disabled={busy || !control.available}
        onClick={onClick}
      >
        {running ? runningLabel : label}
      </Button>
      <span
        className={`text-[12px] ${control.available ? 'text-ui-text-secondary' : 'text-[var(--co-warning)]'}`}
      >
        {control.available ? hint : control.reason}
      </span>
    </li>
  );
}
